import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons/faUndoAlt';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons/faRedoAlt';

const BtnsHistory = ({
  editor,
}) => (
  <>
    <button onClick={() => {
      editor.history.undo();
    }}>
      <FA icon={faUndoAlt} size="xs" />
    </button>
    <button onClick={() => {
      editor.history.redo();
    }}>
      <FA icon={faRedoAlt} size="xs" />
    </button>
  </>
);

export default BtnsHistory;
